import { Box } from "@mui/material";
import { ReactNode } from "react";
import {
  IAction,
  IField,
  IPageable,
  Params,
} from "../../types/table/interfaces.type";
import PaginatedTable from "./PaginatedTable";

interface ISearchableTableProps<T> {
  filters: Params<T>;
  fields: IField<T>[];
  actions?: IAction<T>[];
  fetchFunc:
    | ((params: Params<T>) => Promise<IPageable<T>>)
    | ((id: string) => Promise<T>);
  renderActions?: (row: T) => React.ReactElement[];
  shadeRow?: (row: T) => boolean;
  shadeBg?: string | ((row: T) => string | undefined);
  shadeColor?: string;
  checkboxSelect?: boolean;
  onRowSelect?: (row: T, checked: boolean) => void;
  isRowSelected?: (row: T) => boolean;
  sortableFields?: (keyof T)[];
  highlightDiff?: boolean;
  clientSidePagination?: boolean;
  refreshSignal?: any;
  loading?: boolean;
  paginationSummary?: ReactNode;
}

function SearchableTable<T>({
  fields,
  filters,
  actions = [],
  fetchFunc,
  renderActions,
  shadeRow,
  shadeBg,
  shadeColor,
  checkboxSelect,
  onRowSelect,
  isRowSelected,
  sortableFields,
  highlightDiff = false,
  clientSidePagination = false,
  refreshSignal,
  loading,
  paginationSummary,
  ...props
}: ISearchableTableProps<T>) {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <PaginatedTable<T>
        fields={fields}
        filters={filters}
        actions={actions}
        fetchFunc={fetchFunc}
        renderActions={renderActions}
        shadeRow={shadeRow}
        shadeBg={shadeBg}
        shadeColor={shadeColor}
        checkboxSelect={checkboxSelect}
        onRowSelect={onRowSelect}
        isRowSelected={isRowSelected}
        sortableFields={sortableFields}
        highlightDiff={highlightDiff} // <-- pass directly
        clientSidePagination={clientSidePagination}
        refreshSignal={refreshSignal}
        loading={loading}
        paginationSummary={paginationSummary}
      />
    </Box>
  );
}

export default SearchableTable;
